export default [
  {
    path: '/expert',
    name: 'expert',
    component: () => import(/* webpackChunkName:'treasury'*/ '@/views/expert/ConnectExpert.vue'),
  },
];
